<template>
    <div :class="groupClass" @click="checkPaywallAction()">
        <button type="button" @click="toggleOpen">
            <common-icon :name="icon" size="large"></common-icon>

            <span>{{ label }}</span>

            <div v-if="badge" class="app-main-menu__group--badge-holder">
                <common-badge :content="badge"></common-badge>
            </div>

            <common-icon :class="{ 'arrow-with-badge': !!badge }" name="menu-arrow" size="large"></common-icon>
        </button>

        <app-main-menu-item
            v-for="item in items"
            v-show="!item.isHidden"
            :key="item.label"
            v-bind="item"
            :isNested="true"
            @open-paywall-modal="openPaywallModal"
        ></app-main-menu-item>
    </div>
</template>

<script>
    import { isRouteNameEqual } from '~/helpers'
    import AppMainMenuItem from 'components/layouts/app-layout/AppMainMenuItem'

    export default {
        components: {
            AppMainMenuItem,
        },

        props: {
            label: { type: String, required: true },
            icon: { type: String, required: true },
            items: { type: Array, required: true },
            badge: { type: Number, required: false, default: null },
            showPaywall: { type: Boolean, default: false },
        },

        data() {
            return {
                isOpen: false,
            }
        },

        computed: {
            groupClass() {
                return {
                    'app-main-menu__group': true,
                    'app-main-menu__group--is-open': this.isOpen,
                }
            },
        },

        methods: {
            toggleOpen() {
                if (!this.items.length) {
                    return false
                }
                this.isOpen = !this.isOpen
            },

            checkPaywallAction() {
                if (this.showPaywall && !this.items.length && this.$auth.isUserPracticeDemo()) {
                    this.emitEvent({ name: 'open-paywall-modal' })
                }
            },

            openPaywallModal() {
                this.emitEvent({ name: 'open-paywall-modal' })
            },
        },

        mounted() {
            this.isOpen = this.items.some((item) => (item.route ? isRouteNameEqual(item.route.name, this.$route.name) : false))
        },
    }
</script>
